/**
 * Livacils Mega Menu
 * Desktop hover + keyboard, mobile drawer
 */

(function () {
  'use strict';

  // ─── Desktop mega menu ───────────────────────────────────────────
  const navItems = document.querySelectorAll('.header-nav__item');
  let closeTimeout = null;

  navItems.forEach((item) => {
    const trigger = item.querySelector('[data-mega-menu-trigger]');
    const menu = item.querySelector('.mega-menu');
    if (!trigger || !menu) return;

    const open = () => {
      clearTimeout(closeTimeout);
      document.querySelectorAll('.mega-menu[data-open="true"]').forEach((m) => {
        if (m !== menu) {
          m.removeAttribute('data-open');
          m.previousElementSibling?.removeAttribute('data-active');
        }
      });
      menu.setAttribute('data-open', 'true');
      trigger.setAttribute('data-active', 'true');
    };

    const close = () => {
      closeTimeout = setTimeout(() => {
        menu.removeAttribute('data-open');
        trigger.removeAttribute('data-active');
      }, 150);
    };

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    menu.addEventListener('mouseenter', () => clearTimeout(closeTimeout));
    menu.addEventListener('mouseleave', close);

    // Keyboard
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const isOpen = menu.getAttribute('data-open') === 'true';
        if (isOpen) {
          menu.removeAttribute('data-open');
          trigger.removeAttribute('data-active');
        } else {
          open();
          menu.querySelector('a')?.focus();
        }
      }
      if (e.key === 'Escape') {
        menu.removeAttribute('data-open');
        trigger.removeAttribute('data-active');
        trigger.focus();
      }
    });
  });

  // Close on outside click
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.header-nav__item')) {
      document.querySelectorAll('.mega-menu[data-open="true"]').forEach((m) => {
        m.removeAttribute('data-open');
      });
    }
  });

  // ─── Mobile nav drawer ───────────────────────────────────────────
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');
  const menuToggle = document.querySelector('[data-menu-toggle]');

  if (mobileNav && menuToggle) {
    const open = () => {
      mobileNav.setAttribute('data-open', 'true');
      mobileOverlay?.setAttribute('data-visible', 'true');
      document.body.style.overflow = 'hidden';
      menuToggle.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      mobileNav.removeAttribute('data-open');
      mobileOverlay?.removeAttribute('data-visible');
      document.body.style.overflow = '';
      menuToggle.setAttribute('aria-expanded', 'false');
    };

    menuToggle.addEventListener('click', () => {
      mobileNav.getAttribute('data-open') === 'true' ? close() : open();
    });

    mobileOverlay?.addEventListener('click', close);

    document.querySelector('[data-mobile-nav-close]')?.addEventListener('click', close);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileNav.getAttribute('data-open') === 'true') close();
    });

    // Submenu toggles
    mobileNav.querySelectorAll('[data-submenu-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const submenu = btn.nextElementSibling;
        if (!submenu) return;
        const isOpen = submenu.getAttribute('data-open') === 'true';
        submenu.setAttribute('data-open', String(!isOpen));
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

})();
